import {AjaxGet,AjaxPost} from './Ajax';
import constants from './constants/index';

export default {
}